export default function (order: OrderI): ServerOrderI {
  return {
    id: order.id,
    localId: order.localId || '',
    itemType: order.item.type,
    itemName: order.item.name,
    customizer: {
      stickers: order.stickers,
      lines: order.lines,
      pencils: order.pencils,
      comment: order.customizerComment,
    },
    user: order.user,
    file: order.file,
    files: order.files,
    approveFile: order.approveFile,
    approveComments: order.approveComments,
    comment: order.comment,
    patient: order.patient,
    created: order.created,
    status: order.status,
    approved: order.approved,
    totalPrice: order.totalPrice,
    // userName: '',
    deliveryDetails: order.deliveryDetails,
    billingDetails: order.billingDetails,
    paid: order.paid,
    discount: order.discount,
    configuration: order.configuration,
  };
}
